<template>
  <div class="storeSearch">
    <!-- 头部登录 -->
    <HeaderTop ref="shopcar"></HeaderTop>
    <!-- 头部搜索和tabs -->
    <Header-Search
      :active="'storeSearch'"
      :activeName="'activeName'"
      :flag="2"
      @getlistShop="getlistShop"
    ></Header-Search>
    <Slider></Slider>
    <div style="width: 100%; height: 2px; background: #377cf1"></div>
    <div class="main w">
      <div class="main-top">
        <span>店铺查询</span> &nbsp;<span>&gt;</span>&nbsp;<span>{{
          keyword
        }}</span>
      </div>
      <div class="main-top">
        <span
          >找到相关店铺 <i>{{ this.page.total }}</i> 家</span
        >
      </div>
      <div class="active">
        <div class="left">
          <ul>
            <li
              @click="synthesisChecked"
              :class="checkNum == 0 ? 'checked' : ''"
            >
              综合排序
            </li>
            <li
              @click="inventoryChecked"
              :class="checkNum == 1 ? 'checked' : ''"
            >
              <span>销量</span>
              <div class="rotate">
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.salesVolumeSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.salesVolumeSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li>
            <!-- <li @click="priceChecked" :class="checkNum == 2 ? 'checked' : ''">
              <span>好评率</span>
              <div class="rotate">
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.priceSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.priceSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li> -->
            <li>
              <!-- 店铺类型： -->

              <Select
                v-model="storeType"
                style="width: 200px"
                @on-change="storeChange"
              >
                <Option
                  v-for="item in storeList"
                  :value="item.itemValueOne"
                  :key="item.itemValueOne"
                  >{{ item.itemName }}</Option
                >
              </Select>
            </li>
            <li>
              <!-- 收货地址： -->
              所在地：
              <Select v-model="addressId" style="width: 140px" filterable>
                <Option
                  v-for="item in cityList"
                  :value="item.id"
                  :key="item.id"
                  @click.native="chioce(item)"
                  >{{ item.name }}</Option
                >
              </Select>
            </li>
          </ul>
        </div>
        <div class="right">
          <Checkbox v-model="bought" @on-change="getlistShop"
            >购买过的店铺</Checkbox
          >
        </div>
      </div>

      <div style="display: flex; justify-content: right; margin: 10px 0">
        <Page
          size="small"
          show-total
          :page-size-opts="[30]"
          :current="page.current"
          :page-size="page.size"
          @on-change="changeCurrent"
          @on-page-size-change="changeSize"
          :total="page.total"
        />
        <span
          style="
            line-height: 11px;
            height: 26px;
            padding: 7px 10px;
            border: 1px solid #dcdee2;
            border-radius: 3px;
          "
          >30条/页</span
        >
      </div>
      <!-- 推荐店铺 -->
      <div class="RecommendStore">
        <ul>
          <li v-for="item in RecommendStoreIMGS" :key="item.index">
            <!-- <router-link
              rel="opener"
              :to="{
                path: '/homePage',
                query: {
                  shopId: item.shopId,
                  tenantId: item.id,
                  shopName: item.tenantShortName
                }
              }"
            > -->
            <div class="RecommendStore-div">
              <div>
                <!-- <img src="../../assets/images/home/store-img.jpg" alt="" /> -->
                <img
                  v-show="item.storeImage"
                  :src="item.storeImage || '@/assets/images/home/store-img.jpg'"
                  alt=""
                />
                <img
                  v-show="!item.storeImage"
                  src="@/assets/images/home/store-img.jpg"
                  alt=""
                />
              </div>
              <div class="RecommendStore-div-c">
                <!-- 上 -->
                <div class="RecommendStore-div-top">
                  <p class="p1">
                    <i class="p1-i1" v-show="item.storeType == 5">{{
                      item.storeTypeName || '旗舰店'
                    }}</i>
                    <i class="p1-i2" v-show="item.storeType == 9">{{
                      item.storeTypeName || '自营'
                    }}</i>
                    <i class="p1-i3" v-show="item.storeType == 3">{{
                      item.storeTypeName || '专卖店'
                    }}</i>
                    <i class="p1-i4" v-show="item.storeType == 7">{{
                      item.storeTypeName || '联盟'
                    }}</i>
                    <!-- <span class="iconfont icon-a-zu248"></span> -->
                    <!-- <Tooltip
                      :content="item.tenantShortName"
                      max-width="200"
                      theme="light"
                    >
                      <i class="p1-i2">{{ item.tenantShortName }}</i>
                    </Tooltip> -->
                    <!-- <xiaopei :oppositeTenantId="item.id">
                      <i class="iconfont icon-a-lujing162"></i
                    ></xiaopei> -->
                  </p>
                  <p class="p2">
                    <Tooltip
                      :content="item.tenantShortName"
                      max-width="250"
                      theme="light"
                    >
                      <i class="p1-i2">{{ item.tenantShortName }}</i>
                    </Tooltip>
                  </p>
                  <xiaopei :oppositeTenantId="item.id">
                    <i class="iconfont icon-a-lujing162"></i
                  ></xiaopei>

                  <p class="p3-left">
                    月销量： <i> {{ item.salesVolume }}</i>
                  </p>
                </div>
                <div class="RecommendStore-div-r">
                  <!-- <p>
                    月销量： <i> {{ item.salesVolume }}</i>
                  </p> -->
                  <div class="p2">
                    <!-- <p class="p2"> -->
                    <p>{{ item.provinceName }}{{ item.cityName }}</p>
                    <!-- </p> -->
                    <Tooltip
                      :content="item.carBrandName"
                      max-width="250"
                      theme="light"
                    >
                      <p class="p3">主营车型：{{ item.carBrandName }}</p>
                    </Tooltip>
                    <!-- 好评率： <i> {{ item.applauseRate }}</i> -->
                  </div>
                  <router-link
                    rel="opener"
                    :to="{
                      path: '/homePage',
                      query: {
                        shopId: item.shopId,
                        tenantId: item.id,
                        shopName: item.tenantShortName
                      }
                    }"
                  >
                    进入店铺
                  </router-link>
                </div>
              </div>
            </div>
            <!-- </router-link> -->
          </li>
        </ul>
      </div>
      <!-- <div
        v-if="!RecommendStoreIMGS.length"
        style="height: 300px; text-align: center; padding-top: 100px"
      >
        暂无数据
      </div> -->
      <div class="emptyData" v-if="RecommendStoreIMGS.length == 0">
        <p>
          <span
            ><i
              ><Icon type="ios-alert-outline" size="17" />没找到您想要的数据~</i
            ></span
          >
        </p>
      </div>
      <!-- 加载中 -->
      <div class="demo-spin-container" v-if="spinShow">
        <Spin fix></Spin>
      </div>
      <div>
        <div style="display: flex; justify-content: right; margin-top: 10px">
          <Page
            size="small"
            show-total
            :page-size-opts="[30]"
            :current="page.current"
            :page-size="page.size"
            @on-change="changeCurrent"
            @on-page-size-change="changeSize"
            :total="page.total"
          />
          <span
            style="
              line-height: 11px;
              height: 26px;
              padding: 7px 10px;
              border: 1px solid #dcdee2;
              border-radius: 3px;
            "
            >30条/页</span
          >
        </div>
      </div>
    </div>
    <Footer></Footer>
    <FooterP></FooterP>
  </div>
</template>

<script>
import Slider from '../base/common/slider.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import {
  getlistShop,
  getListAddress,
  getDictionariesItems
} from '../../api/store-search'
// import { getDictionariesItems } from '../../api/payOrder'
import HeaderTop from '../base/common/header-top.vue'
import HeaderSearch from '../base/common/header-search.vue'
import FooterP from '../base/common/footer-p.vue'
import Footer from '../base/common/footer.vue'
export default {
  name: 'storeSearch',
  components: {
    Slider,
    HeaderTop,
    HeaderSearch,
    FooterP,
    Footer,
    xiaopei
  },
  data() {
    return {
      spinShow: true,
      storeType: '1', // 店铺类型
      storeList: [],
      page: {
        current: 1,
        size: 30,
        total: 0
      },
      tenantId: JSON.parse(localStorage.getItem('userdetails_leagueInfo'))
        .tenantId,
      keyword: this.$route.query.storeSearch,
      bought: false,
      RecommendStoreIMGS: [],
      checkNum: 0, // 0/销量 1/库存 2/价格
      inventoryNum: 0, //库存点击次数
      priceNum: 0, //价格点击次数
      searchData: {
        area: 1,
        brandId: '',
        current: 1,
        inStock: '',
        keyword: this.$route.query.storeSearch,
        leagueId: '',
        partType: '',
        priceSort: '', // 价格查询排序,(1升序，2降序)
        shopId: '',
        size: 30,
        salesVolumeSort: '' // 库存查询排序
        // provinceId: '',
        // cityId: '',
        // areaId: ''
      },
      addressId: '', // 收货地址
      cityList: []
    }
  },
  props: {
    activeName: String
  },
  created() {
    this.getListAddress()
  },
  methods: {
    async getlistShop() {
      this.spinShow = true
      const rest = await getDictionariesItems(['DPLX'])
      if (rest.status) {
        this.storeList = rest.data
        this.keyword = this.$route.query.storeSearch
        this.keyword = this.keyword.trim()
      }
      this.searchData.shipCityId =
        this.searchData.shipCityId == '-1' ? '' : this.searchData.shipCityId
      const data = {
        current: this.page.current,
        size: this.page.size,
        storeType: this.storeType,
        bought: Number(this.bought),
        keyword: this.$route.query.storeSearch,
        salesVolumeSort: this.searchData.salesVolumeSort,
        shipCityId: this.searchData.shipCityId
        // provinceId: this.searchData.provinceId,
        // cityId: this.searchData.cityId,
        // areaId: this.searchData.areaId
      }
      console.log(data)
      const res = await getlistShop(data)
      console.log(res)
      if (res.status) {
        this.page.total = res.data.total
        this.RecommendStoreIMGS = res.data.records
      }
      this.spinShow = false
    },
    // 获取收货地址
    async getListAddress() {
      let res = await getListAddress()
      console.log(res)
      this.cityList = res.data
      this.cityList.unshift({ id: '-1', name: '全国' })
      this.addressId = '-1'
      this.searchData.shipCityId = this.addressId
      // res.data.list.forEach((item, index) => {
      //   if (item.preferred == 1) {
      //     this.$nextTick(() => {
      //       this.addressId = index
      //       this.searchData.provinceId = this.cityList[index].provinceId
      //       this.searchData.cityId = this.cityList[index].cityId
      //       this.searchData.areaId = this.cityList[index].countyId
      //     })
      //     console.log(this.addressId)
      //   }
      // })
      console.log(this.addressId)

      this.getlistShop()
    },
    // 分页
    changeCurrent(current) {
      console.log(current)
      this.page.current = current
      this.getlistShop()
    },
    changeSize(size) {
      console.log(size)
      this.page.size = size
      this.getlistShop()
    },
    // 店铺类型
    storeChange(label) {
      this.storeType = label
      this.getlistShop()
    },
    // 改变收货地址
    chioce(item) {
      console.log(item)
      // this.searchData.provinceId = item.provinceId
      // this.searchData.cityId = item.cityId
      // this.searchData.areaId = item.countyId
      this.searchData.shipCityId = item.id
      this.changeListsBtn()
    },
    // // 切换专区
    // headerClick(num) {
    //   this.searchData.area = num
    //   if (num == 1) {
    //     this.bought = false
    //   } else {
    //     this.bought = true
    //   }
    //   this.checkNum = 0
    //   this.inventoryNum = 0
    //   this.searchData.salesVolumeSort = ''
    //   this.priceNum = 0
    //   this.searchData.priceSort = ''
    //   this.changeListsBtn()
    // },
    // 点击综合
    synthesisChecked() {
      this.checkNum = 0
      this.inventoryNum = 0
      this.searchData.salesVolumeSort = ''
      this.priceNum = 0
      this.searchData.priceSort = ''
      this.changeListsBtn()
    },
    // 点击销量
    inventoryChecked() {
      this.checkNum = 1
      this.priceNum = 0
      this.searchData.priceSort = ''
      this.inventoryNum += 1
      console.log(this.inventoryNum)
      if (this.inventoryNum % 2 == 0) {
        console.log(this.inventoryNum % 2)
        this.searchData.salesVolumeSort = 1
      } else {
        this.searchData.salesVolumeSort = 2
      }
      console.log(this.searchData.salesVolumeSort)
      this.changeListsBtn()
    },
    // 点击价格
    // priceChecked() {
    //   this.checkNum = 2
    //   this.inventoryNum = 0
    //   this.searchData.salesVolumeSort = ''
    //   this.priceNum += 1
    //   if (this.priceNum % 2 == 0) {
    //     this.searchData.priceSort = 1
    //   } else {
    //     this.searchData.priceSort = 2
    //   }
    //   console.log(this.searchData.priceSort)
    //   this.changeListsBtn()
    // },
    // 改变按钮（清空搜索条件前的分页条件）
    changeListsBtn() {
      this.page = {
        current: 1,
        size: 30,
        total: 0
      }
      this.page.size = 30
      this.page.current = 1
      this.getlistShop()
    }
  },
  computed: {}
  // watch: {
  //   '$route.query.storeSearch'() {
  //     console.log('111')
  //     this.getlistShop()
  //   }
  // }
}
</script>
<style lang="less" scoped>
.storeSearch {
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .main {
    position: relative;
    .main-top {
      padding-top: 20px;
      i {
        color: #f62b4e;
      }
    }
    .active {
      width: 100%;
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      padding: 0;
      border: 1px solid #e2e2e2;
      background: #f6f6f6;
    }
    .active .left > ul {
      display: flex;
      align-items: center;
    }
    .active .left > ul > li {
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      border-right: 1px solid #e2e2e2;
      opacity: 1;
      border-radius: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .active .left > ul > li:last-child {
      // border: none;
      // padding: 0 20px;
    }

    .active .left > ul > li .rotate {
      transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      /* Firefox */
      -webkit-transform: rotate(90deg);
      /* Safari 和 Chrome */
    }
    .active .left > ul > li .rotate span {
      margin: 0;
      padding: 0;
      font-size: 12px;
    }
    .active .left > ul > li .rotate .checkedLi {
      color: #00348f;
      font-weight: 700;
    }
    .active .left > ul > li /deep/ .ivu-select .ivu-select-selection {
      width: 200px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #b5b5b5;
      opacity: 1;
      border-radius: 2px;
    }
    .active .left > ul > li /deep/ .ivu-select .ivu-select-dropdown {
      width: 200px;
    }
    .active .left > ul .checked {
      background: #e90d0d;
      color: #fff;
    }
    .active {
      height: 40px;
      padding: 0;
      .left > ul {
        display: flex;
        align-items: center;
        > li {
          // width: 100px;
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          // border-right: 1px solid #e2e2e2;
          opacity: 1;
          border-radius: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:nth-child(2) {
            // border-left: none;
          }
          &:last-child {
            // padding: 0 20px;
            border: none;
            // border-right: 1px solid #b5b5b5;
          }
          .rotate {
            transform: rotate(90deg);
            -moz-transform: rotate(90deg); /* Firefox */
            -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
            span {
              margin: 0;
              padding: 0;
              font-size: 12px;
            }
            .checkedLi {
              color: #00348f;
              font-weight: 700;
            }
          }
          /deep/ .ivu-select {
            .ivu-select-selection {
              width: 200px;
              height: 30px;
              background: #ffffff;
              border: 1px solid #b5b5b5;
              opacity: 1;
              border-radius: 2px;
            }
            .ivu-select-dropdown {
              width: 200px;
            }
          }
        }
        .checked {
          background: #377cf1;
          color: #fff;
        }
      }
      // .left {
      //   display: flex;
      //   justify-content: left;
      //   p {
      //     padding: 0 21px;
      //     height: 40px;
      //     line-height: 40px;
      //     opacity: 1;
      //     border-radius: 0px;
      //   }
      //   .active_border {
      //     border-right: 1px solid #e2e2e2;
      //   }
      //   /deep/ .ivu-select {
      //     .ivu-select-selection {
      //       width: 200px;
      //       height: 30px;
      //       background: #ffffff;
      //       border: 1px solid #b5b5b5;
      //       opacity: 1;
      //       border-radius: 2px;
      //     }
      //     .ivu-select-dropdown {
      //       width: 200px;
      //     }
      //   }
      // }
    }
    // 推荐店铺
    .RecommendStore {
      // margin-top: 20px;
      ul {
        flex-wrap: wrap;
        // border-top: 1px solid #e2e2e2;
        // border-left: 1px solid #e2e2e2;
        display: flex;
        li {
          width: 595px;
          height: 120px;
          border: 1px solid #e2e2e2;
          // border-radius: 5px;
          // margin: 0 0 1% 1%;
          margin: 0 0 10px 10px;
          display: flex;

          // a {
          //   width: 100%;
          //   height: 100%;
          img {
            width: 100px;
            height: 100px;
          }
          .RecommendStore-div {
            display: flex;
            padding: 10px 0 10px 10px;
            //   border-right: 1px solid #e2e2e2;
            //   border-bottom: 1px solid #e2e2e2;
            //   // border: 1px solid #e2e2e2;
            //   // height: 600px;
            img {
              width: 100px;
              height: 100px;
            }
            .RecommendStore-div-c {
              // display: flex;
              width: 421px;
              padding: 0 0 0 16px;
              .RecommendStore-div-top {
                // line-height: 28px;
                padding-bottom: 2px;
                border-bottom: 1px solid #e2e2e2;
                display: flex;
                .p1 {
                  margin-top: 2px;
                  // margin-right: 6px;
                  // font-size: 12px;
                  // color: #ff8800;
                  .p1-i1 {
                    color: #f62b4e;
                    font-size: 12px;
                    border: 1px solid #f62b4e;
                    margin-right: 3px;
                  }
                  .p1-i2 {
                    color: #ff5e00;
                    font-size: 12px;
                    border: 1px solid #ff5e00;
                    margin-right: 9px;
                  }
                  .p1-i3 {
                    color: #47c460;
                    font-size: 12px;
                    border: 1px solid #47c460;
                    margin-right: 3px;
                  }
                  .p1-i4 {
                    color: #377cf1;
                    font-size: 12px;
                    border: 1px solid #377cf1;
                    margin-right: 3px;
                  }
                  .icon-a-zu248 {
                    font-size: 15px;
                    line-height: 12px;
                  }
                }
                .p2 {
                  // line-height: 16px;
                  font-size: 16px;
                  font-weight: bold;
                  color: #444650;
                  /deep/ .ivu-tooltip > .ivu-tooltip-rel > .p1-i2 {
                    display: inline-block;
                    font-weight: bold;
                    max-width: 210px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    letter-spacing: 1px;
                    cursor: pointer;
                    padding: 0 6px 0 0;
                    // padding-left: 6px;
                    // padding-right: 4px;
                  }
                }
                .icon-a-lujing162 {
                  color: #0077ff;
                  // margin-top: 3px;
                  font-size: 16px;
                  margin-bottom: 2px;
                }
                .p3-left {
                  font-weight: 500;
                  font-size: 12px;
                  color: #b0adb0;
                  margin-left: auto;
                  padding-top: 9px;
                }
              }
              .RecommendStore-div-r {
                display: flex;
                justify-content: space-between;
                padding-top: 16px;
                .p2 {
                  // font-size: 12px;
                  p {
                    font-size: 12px;
                    color: #b0adb0;
                  }
                  .p3 {
                    width: 250px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    letter-spacing: 1px;
                    cursor: pointer;
                  }
                }
                a {
                  width: 80px;
                  height: 30px;
                  text-align: center;
                  padding-top: 3px;
                  // line-height: 30px;
                  // font-size: 14px;
                  display: inline-block;
                  color: #ffffff;
                  // padding: 2px 11px;
                  background: #ff5e00;
                  border-radius: 4px;
                  padding-top: 3px;
                  // line-height: 14px;
                  // span {
                  //   cursor: pointer;
                  // }
                }
                // a:hover {
                //   background: #f47831;
                //   border: 1px solid #e47d41;
                // }
              }
              // .p1 {
              //   display: flex;
              //   .p1-i1 {
              //     font-size: 12px;
              //     line-height: 12px;
              //     // padding: 1px 2px 3px 3px;
              //     color: #ff8800;
              //     border: 1px solid #ff8800;
              //     // border-radius: 4px;
              //   }
              //   .p1-i2 {
              //     display: inline-block;
              //     font-weight: 400;
              //     font-size: 12px;
              //     color: #676767;
              //     width: 200px;
              //     overflow: hidden;
              //     text-overflow: ellipsis;
              //     white-space: nowrap;
              //     letter-spacing: 1px;
              //     cursor: pointer;
              //     font-weight: 700;
              //     font-size: 16px;
              //   }
              //   .icon-a-zu248 {
              //     color: #ff8800;
              //     font-size: 18px;
              //     // margin: 0 5px;
              //   }
              //   .icon-a-lujing162 {
              //     cursor: pointer;
              //     font-size: 18px;
              //     color: #0077ff;
              //     margin: 0 5px;
              //   }
              // }
              // .p2 {
              //   margin: 23px 0;
              // }
              // .p3 {
              //   display: inline-block;
              //   font-weight: 400;
              //   font-size: 12px;
              //   color: #676767;
              //   width: 200px;
              //   overflow: hidden;
              //   text-overflow: ellipsis;
              //   white-space: nowrap;
              //   letter-spacing: 1px;
              //   cursor: pointer;
              // }
            }
          }
          .RecommendStore-div-r {
            //   padding-top: 16px;
            //   p > i {
            //     color: #e90d0d;
            //   }
            //   .p2 {
            //     margin: 23px 0;
            //   }
            //   .p3 {
            //     display: inline-block;
            //     font-weight: 400;
            //     font-size: 12px;
            //     color: #676767;
            //     width: 200px;
            //     overflow: hidden;
            //     text-overflow: ellipsis;
            //     white-space: nowrap;
            //     letter-spacing: 1px;
            //     cursor: pointer;
            //   }
            //   a {
            //     color: #ffffff;
            //     padding: 7px 16px;
            //     background: #ff5e00;
            //     border-radius: 4px;

            //     span {
            //       cursor: pointer;
            //     }
            //   }
            // }
          }
        }
        li:nth-child(odd) {
          margin-left: 0;
        }
      }
    }
    // 空数据提示
    .emptyData {
      border: 1px solid #e2e2e2;
      border-top: none;
      text-align: center;
      line-height: 200px;
      height: 300px;
    }
    /deep/.demo-spin-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      opacity: 0.5;
      .ivu-spin-fix {
        width: 100%;
        height: 400px;
        .ivu-spin-main {
          top: 75%;
        }
      }
    }
    .ivu-page {
      text-align: right;
      // padding: 18px 0;
      /deep/ .ivu-page-options-sizer {
        margin-right: 0;
      }
    }
  }
}
</style>
